import { render, staticRenderFns } from "./Slide1M.vue?vue&type=template&id=2ef34628&scoped=true&"
import script from "./Slide1M.vue?vue&type=script&lang=js&"
export * from "./Slide1M.vue?vue&type=script&lang=js&"
import style0 from "./Slide1M.vue?vue&type=style&index=0&id=2ef34628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef34628",
  null
  
)

export default component.exports